export default __webpack_public_path__ + "static/media/giuseppe.287c3a73.jpg";